import { useWindowSize } from "@vueuse/core";

const { width } = useWindowSize();

export function isMobile() {
    return width.value < 1000;
}
